import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const parcelTypeLocaleModule: LocaleModule = {
  name: "parcelType",
  messages: { en: en, it: it },
};
